export enum Endpoint {
  TOKEN = '/auth/jwt/token',
  REVOKE_TOKEN = '/auth/jwt/revoke',
  REFRESH_TOKEN = '/auth/jwt/refresh',
  FORGOT_PASSWORD = '/auth/forgot-password',
  RESET_PASSWORD = '/auth/reset-password',
  VALIDATE_ACCOUNT = 'validate-account',
  ACTIVATE_ACCOUNT = '/auth/activate',
  ME = '/auth/me',
  UNITS = '/units',
  INSTANCES = '/instances',
  USERS = '/users',
  BUILDINGS = '/buildings',
  UNIT_IMAGES = '/images/unit',
  BUILDING_IMAGES = '/images/building',
  LEADS = '/leads',
  REPORTS = '/reports',
  POIS = '/pois',
  PERSPECTIVES = '/perspectives',
  GENERAL_INFORMATION = '/infos',
  PROFILE = '/profile',
  EMAIL_TEMPLATES = '/email-templates',
  FEATURES = '/features',
  APPLICATIONS = '/applications',
  OFFERS = '/offers',
  CONTRACTS = '/contracts',
  FILES = '/files',
  IMAGES = '/images',
}
